import React from 'react';
import { Box, Divider, StatusIndicator, Text, Tooltip } from '@wix/design-system';
import { WidgetButton } from '../../../CommonWidgets/shared/WidgetButton/WidgetButton';
import { WidgetLayout } from '../../../CommonWidgets/shared/WidgetLayout/WidgetLayout';
import { useDisabledWidget } from '../../../../shared/disabled-widget/useDisabledWidget';
import { WithDisabledControl } from '../../../../shared/disabled-widget/WithDisabledControl';
import { InfoCircle } from '@wix/wix-ui-icons-common';
import { StyledMarkdownText } from '../../ProactiveMarketingAssistant/common/TextTyper/StyledMarkdownText';
import styles from './AppliedCodeWidget.scss';
export const AppliedCodeWidget = _ref => {
  let {
    data: {
      primaryButton,
      secondaryButton,
      appliedAction,
      text,
      bottomText
    },
    context,
    config
  } = _ref;
  const {
    areControlsDisabled,
    enableControls
  } = useDisabledWidget(config);
  const handleButtonClick = function (action, label) {
    if (label === void 0) {
      label = '';
    }
    const handler = effects => {
      const onWidgetActionData = {
        action,
        value: {
          label,
          effects
        }
      };
      context.onWidgetAction(APPLIED_CODE_WIDGET, onWidgetActionData);
    };
    return handler;
  };
  return /*#__PURE__*/React.createElement(WidgetLayout, {
    context: context,
    disabled: areControlsDisabled,
    onEnableControls: enableControls
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    boxSizing: "border-box",
    containerType: "inline-size",
    gap: "10px"
  }, ((appliedAction == null ? void 0 : appliedAction.header) || (appliedAction == null ? void 0 : appliedAction.body)) && /*#__PURE__*/React.createElement("div", {
    className: styles.appliedActionContainer
  }, appliedAction.header && /*#__PURE__*/React.createElement(Box, {
    gap: "8px",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(StatusIndicator, {
    status: "success"
  }), /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, appliedAction.header)), appliedAction.body && /*#__PURE__*/React.createElement(StyledMarkdownText, {
    className: styles.actionBody
  }, appliedAction.body)), text && /*#__PURE__*/React.createElement(StyledMarkdownText, null, text), /*#__PURE__*/React.createElement(Box, {
    align: "right"
  }, (primaryButton == null ? void 0 : primaryButton.label) && /*#__PURE__*/React.createElement(WithDisabledControl, {
    t: context.t,
    isDisabled: areControlsDisabled,
    onEnable: () => {}
  }, /*#__PURE__*/React.createElement(WidgetButton, {
    context: context,
    webAction: primaryButton.webAction,
    onClick: handleButtonClick('primary_button_click', primaryButton == null ? void 0 : primaryButton.label),
    respondText: primaryButton.respondText,
    icon: primaryButton.icon,
    sideEffect: primaryButton.sideEffect,
    disabled: areControlsDisabled,
    skin: primaryButton.skin
  }, primaryButton.label))), ((secondaryButton == null ? void 0 : secondaryButton.label) || bottomText) && /*#__PURE__*/React.createElement(Divider, null), ((secondaryButton == null ? void 0 : secondaryButton.label) || bottomText) && /*#__PURE__*/React.createElement(Box, {
    gap: "10px",
    verticalAlign: "middle",
    align: "space-between"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, bottomText), /*#__PURE__*/React.createElement(Box, {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      gap: '2px'
    }
  }, (secondaryButton == null ? void 0 : secondaryButton.label) && /*#__PURE__*/React.createElement(WithDisabledControl, {
    t: context.t,
    isDisabled: areControlsDisabled,
    onEnable: enableControls
  }, /*#__PURE__*/React.createElement(WidgetButton, {
    type: "textButton",
    context: context,
    onClick: handleButtonClick('secondary_button_click', secondaryButton == null ? void 0 : secondaryButton.label),
    webAction: secondaryButton.webAction,
    respondText: secondaryButton.respondText,
    icon: secondaryButton.icon,
    sideEffect: secondaryButton.sideEffect,
    skin: secondaryButton.skin
  }, secondaryButton.label)), (secondaryButton == null ? void 0 : secondaryButton.tooltip) && /*#__PURE__*/React.createElement(Tooltip, {
    content: secondaryButton.tooltip
  }, /*#__PURE__*/React.createElement(InfoCircle, {
    size: 18
  }))))));
};
export const APPLIED_CODE_WIDGET = 'APPLIED_CODE_WIDGET';
//# sourceMappingURL=AppliedCodeWidget.js.map